



































import { computed, defineComponent, ref } from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import { JOB_EVENT_MAIL_VARIABLE_PREVIEW } from "@/helpers/jobEvent";
import OccSelectbox from "@/components/Atoms/OccSelectbox/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";
import OccToggleCheckbox from "@/components/Atoms/OccToggleCheckbox/index.vue";
import EmptyView from "@/components/Atoms/EmptyView/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";

import { JobEventScheduleMailKey } from "@/api/types";
import { useRequest } from "@/helpers/hooks/useRequest";
import {
  getEventMailTemplateVariables,
  updateJobEventMailNotificationTypes
} from "@/api";
import { JOB_EVENT_STORE_KEY } from "@/helpers/hooks/useJobEvent";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";

export default defineComponent({
  components: {
    OccHeading,
    OccSelectbox,
    TextArea,
    OccModal,
    Caption,
    OccButton,
    OccTag,
    ListTable,
    OccToggleCheckbox,
    EmptyView
  },
  name: "MailToggleList",
  setup(_, { root }) {
    const {
      editingJobEvent,
      setEditingJobEvent,
      defaultMailTemplates,
      refreshEditingJobEvent
    } = useGlobalState(JOB_EVENT_STORE_KEY);

    const [{ data: mailTemplateVariables }] = useRequest(
      () => getEventMailTemplateVariables(),
      { immediate: true }
    );

    refreshEditingJobEvent();

    const eventId = Number(root.$route.params.eventId);
    const selectedMailKey = ref<JobEventScheduleMailKey | undefined>();
    const enabledResume = computed(
      () => !!editingJobEvent.value?.resume_questions.length
    );

    const enabledLottery = computed(() => editingJobEvent.value?.is_lottery);
    const headers = [
      {
        name: "メール種別",
        subHeaders: [{ name: "メール説明" }],
        minSizeContainer: "914px"
      },
      {
        name: "",
        minSizeContainer: "70px"
      }
    ];

    const getChecked = (mailType: JobEventScheduleMailKey) => {
      switch (mailType) {
        case "pre_entry":
          return enabledResume.value;
        case "entry":
          return enabledLottery.value;
        case "pass":
          return !enabledLottery.value;
        case "elected":
          return enabledLottery.value;
        case "defeated":
          return enabledLottery.value;
        case "reminder":
          return editingJobEvent.value?.mail_notifications.reminder;
        case "thanks":
          return editingJobEvent.value?.mail_notifications.thanks;
        case "user_canceled":
          return true;
        case "schedule_canceled":
          return true;
      }
    };

    const updateMailNotificationTypes = () => {
      if (editingJobEvent.value === undefined) {
        return;
      }

      const mailNotificationTypes = [];
      if (editingJobEvent.value.mail_notifications.thanks) {
        mailNotificationTypes.push("thank_you");
      }
      if (editingJobEvent.value.mail_notifications.reminder) {
        mailNotificationTypes.push("event_remained");
      }
      if (enabledLottery.value) {
        mailNotificationTypes.push("elected", "defeated");
      }
      let params = {
        eventId: eventId,
        mail_notification_types: mailNotificationTypes
      };

      updateJobEventMailNotificationTypes(params);
    };

    const onClickCheckBox = (mailType: JobEventScheduleMailKey) => {
      switch (mailType) {
        case "reminder":
          if (editingJobEvent.value) {
            setEditingJobEvent({
              ...editingJobEvent.value,
              mail_notifications: {
                ...editingJobEvent.value.mail_notifications,
                reminder: !editingJobEvent.value.mail_notifications.reminder
              }
            });
          }
          break;
        case "thanks":
          if (editingJobEvent.value) {
            setEditingJobEvent({
              ...editingJobEvent.value,
              mail_notifications: {
                ...editingJobEvent.value.mail_notifications,
                thanks: !editingJobEvent.value.mail_notifications.thanks
              }
            });
          }
          break;
      }
      updateMailNotificationTypes();
      return;
    };

    return {
      defaultMailTemplates,
      JOB_EVENT_MAIL_VARIABLE_PREVIEW,
      editingJobEvent,
      enabledResume,
      enabledLottery,
      mailTemplateVariables,
      selectedMailKey,
      getChecked,
      onClickCheckBox,
      updateJobEventMailNotificationTypes,
      headers
    };
  }
});
